
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'button',
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const emitClick = (event: MouseEvent) => {
            if (props.loading || props.disabled) return
            emit('click', event)
        }

        return {
            emitClick,
        }
    },
})
